import React from 'react';
import PropTypes from 'prop-types';
import { Form as FinalForm, Field, FORM_ERROR } from 'react-final-form';
import {
  Button,
  Panel,
  Form,
  FormGroup,
  ControlLabel,
} from 'react-bootstrap';
import Toggle from 'react-bootstrap-toggle';

import DatePicker from 'react-datepicker2';
import 'react-datepicker2/dist/react-datepicker.css';
import request from 'superagent';
import {notify} from 'common/Notification';
import {updateConnection} from "../../redux/actions/integrationsConnectionActions";

const datePickerAdapter = ({ input: {onChange, value}, ...rest }) => {
  // console.log("Picker value", value);
  return (
    <DatePicker
      selected={value}
      onChange={newDate => onChange(newDate)}
      {...rest}
    />
  );
};

const toggleAdapter = ({ input: {onChange, value}, ...rest }) => (
  <Toggle
    active={!!value}
    onClick={() => onChange(!value)}
    { ...rest }
  />
);

const syncModeToggleAdapter = ({ input: { onChange, value}, ...rest}) => (
  <Toggle
    active={value === 'user'}
    onClick={() => onChange(value === 'user' ? 'firm' : 'user')}
    { ...rest }
  />
);

export default class FileSyncSettings extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number.isRequired,
    syncType: PropTypes.string.isRequired,
    syncFrom: PropTypes.instanceOf(Date).isRequired,
    combinePDFs: PropTypes.bool.isRequired,
    syncMode: PropTypes.string.isRequired,
  };

  initialState = {
    isLoading: false,
    error: null,
  };

  constructor(props) {
    super(props);
    this.state = {...this.initialState};
  }

  formInitialValues() {
    return {
      use_start_date: (this.props.syncType === 'new'),
      sync_from: this.props.syncFrom,
      combine_pdfs: this.props.combinePDFs,
      sync_mode: this.props.syncMode,
    };
  }

  onSave(settings) {
    const values = {
      sync_type: (settings.use_start_date ? 'new' : 'full'),
      sync_from: settings.sync_from.toISOString(),
      combine_pdfs: settings.combine_pdfs,
      sync_mode: settings.sync_mode,
    };

    return request.patch(`/rpc/integrations/connections/${this.props.connectionId}`)
      .send(values)
      .then(
        res => {
          notify.success('Document Upload Settings Saved');
          console.log("Received update: ", res.body);
          this.props.dispatch(updateConnection(this.props.connectionId, res.body));
        },
        errRes => {
          return {[FORM_ERROR]: 'Error Saving Document Upload Settings'};
        }
      );
  }

  render() {
    return (
      <FinalForm
        onSubmit={settings => this.onSave(settings)}
        initialValues={ this.formInitialValues() }
      >
        {({handleSubmit, form, submitting, pristine, values}) =>
          <Form onSubmit={handleSubmit}>
            {/* <pre>VALUES: {JSON.stringify(values, null, 2)}</pre> */}
            <Panel>
              <Panel.Heading>
                <Panel.Title>How should we upload your PDFs?</Panel.Title>
              </Panel.Heading>
              <Panel.Body>
                <FormGroup>
                  <Field name="use_start_date" component={toggleAdapter} size="xs" onstyle={"success"} />
                  {' '} <ControlLabel>Restrict Uploads to a Specific Start Date</ControlLabel>
                </FormGroup>
                { values.use_start_date &&
                  <FormGroup>
                    <ControlLabel>
                      Only upload documents accruing to my account on or after:
                    </ControlLabel>
                    <br/>
                    <Field
                      name="sync_from"
                      component={datePickerAdapter}
                      placeholder="Select a starting date"
                      todayButton="Today"
                      dateFormat="MM/dd/yyyy"
                    />
                  </FormGroup>
                }
                <FormGroup>
                  <Field name="combine_pdfs" component={toggleAdapter} size="xs" onstyle={"success"} />
                  {' '} <ControlLabel>Upload combined PDFs (leave OFF to upload exhibits as separate PDFs)</ControlLabel>
                </FormGroup>

                <FormGroup>
                  <Field name="sync_mode" component={syncModeToggleAdapter} size="xs" onstyle={"success"} />
                  {' '}<ControlLabel>Restrict uploads to my CaseFolders only (leave OFF to upload PDFs for all Firm CaseFolders)</ControlLabel>
                </FormGroup>

                <FormGroup>
                  <Button type="submit" bsStyle="primary" disabled={pristine || submitting}>Save</Button>
                </FormGroup>
              </Panel.Body>
            </Panel>
          </Form>
        }
      </FinalForm>
    );
  };
};



// WEBPACK FOOTER //
// ./src/Integrations/connections/FileSyncSettings.jsx